import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayModes } from '../../models/enums';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { AppTranslationService } from '../../services/app-translation.service';
import { AgreementService } from '../agreement.service';
import { ItemService } from '../../lookups/item/item.service';
import { ItemsApiService } from '../../lookups/services/items-api.service';
import { HelperMethodsService } from '../../services/helper-methods.service';
import { HcoService } from '../../settings/components/hco/hco.service';

@Component({
  selector: 'crm-add-agreement',
  templateUrl: './add-agreement.component.html',
  styleUrls: ['./add-agreement.component.css']
})
export class AddAgreementComponent implements OnInit {

  displayMode: DisplayModes = DisplayModes.Success;
  agreement: any = {};
  itemBrands: any[] = [];
  items: any[] = [];
  itemsFiltered: any[] = [];
  hcps: any[] = [];

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() agreementId: number;
  agreementDate: any;
  constructor(private readonly agreementService: AgreementService, private readonly helperMethods: HelperMethodsService,
    private readonly route: ActivatedRoute, private readonly itemService: ItemService, private readonly hcoService: HcoService,
    private readonly router: Router, private readonly itemsApiService: ItemsApiService,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    this.getItems();
    this.getHcps();
    this.getItemBrands();

    if (this.agreementId != undefined)
      this.getAgreement(this.agreementId);
  }

  getAgreement(agreementId) {
    this.displayMode = DisplayModes.Loading;
    this.agreementService.getById(agreementId).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.agreement = responce as any;


      if (this.agreement.itemBrandId && this.itemBrands)
        this.agreement.itemBrand = this.itemBrands.find(x => x.id == this.agreement.itemBrandId);
      if (this.agreement.itemId && this.items)
        this.agreement.item = this.items.find(x => x.id == this.agreement.itemId);
      if (this.agreement.hcpId && this.hcps)
        this.agreement.hcp = this.hcps.find(x => x.id == this.agreement.hcpId);


      if (this.agreement.agreementDate !== null) {
        this.agreementDate = {
          year: new Date(this.agreement.agreementDate).getFullYear(),
          month: new Date(this.agreement.agreementDate).getMonth() + 1,
          day: new Date(this.agreement.agreementDate).getDate()
        }
      }

    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get agreement');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid && this.agreement.targetQuantity > 0 && this.agreement.targetValue > 0) {


      this.displayMode = DisplayModes.Loading;

      if (this.agreementDate !== undefined)
        this.agreement.agreementDate = this.helperMethods.convertDateToUTC(new Date(this.agreementDate.year, this.agreementDate.month - 1, this.agreementDate.day + 1));


      if (this.agreement.item)
        this.agreement.itemId = this.agreement.item.id;
      if (this.agreement.itemBrand)
        this.agreement.itemBrandId = this.agreement.itemBrand.id;
      if (this.agreement.hcp)
        this.agreement.hcpId = this.agreement.hcp.id;


      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.agreementService.save(this.agreement).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

  getItemBrands() {
    this.itemService.getAllItemBrandss().subscribe(response => {
      this.itemBrands = response as any[];
      if (this.agreement && this.agreement.itemBrandId && this.itemBrands)
        this.agreement.itemBrand = this.itemBrands.find(x => x.id == this.agreement.itemBrandId);


    }, error => { });
  }


  getItems() {
    this.itemsApiService.getAllItemsMini().subscribe(response => {
      this.items = response as any[];
      this.itemsFiltered = response as any[];
      if (this.agreement && this.agreement.itemId && this.items)
        this.agreement.item = this.items.find(x => x.id == this.agreement.itemId);
    }, error => { });
  }

  getHcps() {
    this.hcoService.getAllUserHcps().subscribe(response => {
      this.hcps = response as any[];
      if (this.agreement && this.agreement.hcpId && this.hcps)
        this.agreement.hcp = this.hcps.find(x => x.id == this.agreement.hcpId);
    }, error => { });
  }

  onSelectItemBrand(agreement) {
    if (agreement && agreement.itemBrand) {
      this.itemsFiltered = this.items.filter(x => x.itemBrandId == agreement.itemBrand.id)
    }
    else {
      this.itemsFiltered = Object.assign(this.items)
    }
  }

}
